import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { RouterModule } from '@angular/router';

import { ConfigService } from '../services/config.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { TableComponent } from './components/table/table.component';
import { HasPermissionDirective } from './directives/haspermission.directive';
import { MaterialModule } from './modules/material/material.module';

@NgModule({
  declarations: [],
  exports: [MaterialModule, HasPermissionDirective],
  imports: [
    HasPermissionDirective,
    MaterialModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    CdkDrag,
    CdkDragHandle,
    TableComponent,
  ],
  providers: [
    HttpClient,
    LocalStorageService,
    ConfigService,
    DatePipe,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
